function testingFunction (argument) {
	console.log('ha ha');
}

function testWidthJs(){
	if(Foundation.MediaQuery.atLeast('large')){
		console.log('large!');
	}
}

module.exports = {
	testingFunction: testingFunction,
	testWidthJs: testWidthJs
};



// WEBPACK FOOTER //
// ./assets/scripts/components/sample.js